import { render, staticRenderFns } from "./TrendyolIcon.vue?vue&type=template&id=687878a6&scoped=true"
import script from "./TrendyolIcon.vue?vue&type=script&lang=js"
export * from "./TrendyolIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687878a6",
  null
  
)

export default component.exports